import { DeleteCompany } from "./DeleteCompany";
import { DeleteDriver } from "./DeleteDriver";
import { DeleteOrder } from "./DeleteOrder";
import { DeleteScheduling } from "./DeleteScheduling";
import { DeleteTruck } from "./DeleteTruck";

export const Delete = {
  Order: DeleteOrder,
  Scheduling: DeleteScheduling,
  Company: DeleteCompany,
  Truck: DeleteTruck,
  Driver: DeleteDriver
};
